import { Theme as AugmentedTheme } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';
import React from 'react';
import { Box, KeyValue, Grid } from 'web-library';
import { useTranslation } from 'react-i18next';
import FormHeader from '../../../components/form-items/FormHeader';

const useStyles = makeStyles()((theme) =>
({
  container: {
    paddingBottom: theme.spacing(2),
  },
}));

export interface PersonalDetailsProps {
  statutoryName?: string;
  nricFin?: string | null;
}

const PersonalDetails = ({
  statutoryName = '',
  nricFin = '',
}: PersonalDetailsProps) => {
  const { classes } = useStyles();
  const { t } = useTranslation();

  return (
    <Box className={classes.container}>
      <FormHeader title={t('components->>PersonalDetails.Candidate Details')} />

      <KeyValue
        id="candidateName"
        keyText={t('components->>PersonalDetails.Name')}
        valueText={statutoryName}
      />

      <Grid container direction="row">
        <Grid md={5} sm={12} xs={12}>
          <KeyValue
            id="nricFinPassport"
            keyText={t('components->>PersonalDetails.NRIC/FIN/Passport No.')}
            valueText={nricFin || ''}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default PersonalDetails;
